import {
    FETCH_STORYBOARD_PARTICIPATION_FAILED,
    FETCH_STORYBOARD_PARTICIPATION_START,
    FETCH_STORYBOARD_PARTICIPATION_SUCCESS
} from '../../constants';
import { GET_PARTICIPATON_RATE_URL } from '../../../../config/constants';
import { ApiBase } from '../../../utils/apiBase';
import { withType } from '../../../utils/actionOperations';
import { getProjectIdAndOrgId } from '../../../utils/apiUtils';

export const fetchStoryboardParticipationRate = (payload, cb) => {
    const apiBaseInstance = new ApiBase();
    payload = {
        ...payload,
        isRequestFromStoryBoard: true,
        page: "compare",
    }
    return dispatch => {
        dispatch(withType(FETCH_STORYBOARD_PARTICIPATION_START, {}));
        apiBaseInstance.instance
            .post(GET_PARTICIPATON_RATE_URL, { ...payload, ...getProjectIdAndOrgId(payload) })
            .then(response => {
                dispatch(withType(FETCH_STORYBOARD_PARTICIPATION_SUCCESS, {
                    data: { ...response.data, projectData: payload },
                    message: response.message,
                }));
                setTimeout(() => {
                    cb && cb();
                }, 0)
            })
            .catch(err => {
                dispatch(withType(FETCH_STORYBOARD_PARTICIPATION_FAILED, {
                    error: err
                }));
            });
    };
};

